import { Inject, Injectable, PLATFORM_ID, inject, signal } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { Router } from '@angular/router';
import { LocalStorageService } from './local-storage.service';
import { lastValueFrom, Subject, forkJoin} from 'rxjs';
import { IColumn, IDataTableParam, IDataTableResponse, IRequestQuery, METHOD_TYPE } from '../models/DataTable';
import { EVENT_DATA, USERINFO } from '../models/service';
import { environment } from '../environment';
import { isPlatformBrowser} from "@angular/common";
declare let Bs5Utils: any;
import JSEncrypt from 'jsencrypt';
import * as CryptoJS from 'crypto-js';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap/modal';
import { AlertBox } from '../components/alert-box/alert-box';
import { APP_CONSTANTS } from '../app.constants';
//
@Injectable({
  providedIn: 'root'
})
export class ApiService{
  public defaultDailCode  = environment.defaultDailCode;
  public OTPWaitingSecond = environment.OTP_WAITING_SECOND;
  private APIURL =environment.apiBaseUrl;
  modalRef: any; 
  bs5Utils:any;
  browserStorageService = inject(LocalStorageService);  
  private catchLoaderSubject = new Subject();
  onCatchLoaderChange = this.catchLoaderSubject.asObservable(); 

  public profile = signal<USERINFO>(<USERINFO>{});
  private defaultEvent: EVENT_DATA = { eventType: '', eventObj:null };
  public currentEvent = signal<EVENT_DATA>(this.defaultEvent);
  public isLoggedIn = signal<boolean>(false);
  
  private jsEncrypt = new JSEncrypt();
  private isKeyLoaded :boolean =false;

  private modalService = inject(NgbModal);
  EntityTypes:any = APP_CONSTANTS.ENTITY_TYPE_KEY as any;
  constructor(private http: HttpClient,private router: Router, @Inject(PLATFORM_ID) private platformId: Object) {     
    if (isPlatformBrowser(this.platformId)) {
        setTimeout(() => {
          Bs5Utils.defaults.toasts.position = 'top-right';  
          this.bs5Utils = new Bs5Utils(); 
          if(!this.isKeyLoaded && this.browserStorageService.publicKeyString && this.jsEncrypt){
            this.jsEncrypt.setPublicKey(this.browserStorageService.publicKeyString.split("\r\n").join("\r\n"));  
            this.isKeyLoaded = true;          
          }         
        }, 2000);        
    } 
  }  
  getIVRESKey(){   
    const aesKey =  CryptoJS.enc.Utf8.parse('2tqi/8QkFJ7*T7Wp').toString();    
    const ivKey = CryptoJS.enc.Utf8.parse('84gHIp_qb£8t3mkp').toString(); 
    return {
      AES : aesKey,
      IV: ivKey
    };
  }
  encryptString(inputString:any){
    const AesObj = this.getIVRESKey();     
    const encryptedPayload = CryptoJS.AES.encrypt(inputString, CryptoJS.enc.Utf8.parse(AesObj.AES), { iv: CryptoJS.enc.Utf8.parse(AesObj.IV) }).toString(CryptoJS.format.Hex);    
    return encryptedPayload;
  }
  decryptString(encryptedPayload:any){
    if(!encryptedPayload) return encryptedPayload;    
    const AesObj = this.getIVRESKey(); 
    const encryptedValue = CryptoJS.enc.Hex.parse(encryptedPayload).toString(CryptoJS.enc.Base64);
    const decryptedPayload = CryptoJS.AES.decrypt(encryptedValue, CryptoJS.enc.Utf8.parse(AesObj.AES), { iv: CryptoJS.enc.Utf8.parse(AesObj.IV) }).toString(CryptoJS.enc.Utf8);
    ////console.log('decryptedPayload', decryptedPayload);
    return decryptedPayload;
  }
  generateRandomPassword(length=8){    
    const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const lower = "abcdefghijklmnopqrstuvwxyz";
    const numbers = "0123456789";
    const special =  "*&^%$#@!?><{}";
    const allChars = upper + lower + numbers + special;

    let password = [
      upper[Math.floor(Math.random() * upper.length)],
      lower[Math.floor(Math.random() * lower.length)],
      numbers[Math.floor(Math.random() * numbers.length)],
      special[Math.floor(Math.random() * special.length)]
    ];
    for (let i = password.length; i < length; i++) {
      password.push(allChars[Math.floor(Math.random() * allChars.length)]);
    }
    password = password.sort(() => Math.random() - 0.5);
    return password.join("");

  }
  updateLoginProfileData(newProfile:USERINFO){
    if(newProfile && newProfile.UserID>0){  
      this.browserStorageService.set(this.browserStorageService.userKey, JSON.stringify(newProfile)).subscribe({
        next:()=>{
          this.updateProfile(newProfile)
        }
      });              
    } 
  }
  updateUserCurrency(currencyCode:string){
    if(currencyCode){  
      this.browserStorageService.set(this.browserStorageService.userCurrencyCodeKey, currencyCode.toUpperCase()).subscribe();              
    } 
  }
  updateProfile(newProfile: Partial<USERINFO>) {    
    this.profile.update(current => ({ ...current, ...newProfile }));
  }
  publishChange(event:EVENT_DATA){     
    this.currentEvent.set(event);
  }//EOF publishChange 

  updateLoginStatus(status:boolean){     
    this.isLoggedIn.set(status);
  }//EOF updateLoginStatus 
  
  requestGet(endUrl: string) {
    return this.http.get(this.APIURL + endUrl);
  }//EOF 

  requestDelete(endUrl: string) {
    return this.http.delete(this.APIURL + endUrl);
  }//EOF 

  requestPost(endUrl: string, datarequest?: any,isJson ?: boolean) {
    datarequest = datarequest || {};
    let postParams = datarequest || {};
    if(!isJson){
      postParams  = new FormData();
      for(let k in datarequest){
        postParams.append(k, datarequest[k]);
      }
    }
    return this.http.post(this.APIURL + endUrl, postParams);
  }//EOF
   
  requestPut(endUrl: string, datarequest?: any,isJson ?: boolean) {
    datarequest = datarequest || {};
    let postParams = datarequest || {};
    if(!isJson){
      postParams  = new FormData();
      for(let k in datarequest){
        postParams.append(k, datarequest[k]);
      }
    }    
    return this.http.put(this.APIURL + endUrl, postParams);
  }//EOF requestPost

  // Remove JWT token
  logout(isRedirectRequired?:boolean): void {   
    const doRedirect = isRedirectRequired ?? true;  
    forkJoin([
      this.browserStorageService.delete(this.browserStorageService.tokenKey), 
      this.browserStorageService.delete(this.browserStorageService.userKey)
    ]).subscribe((res:any)=>{ 
      this.publishChange({eventType:'USER_INFO',eventObj: {}});           
      if(doRedirect)this.router.navigate(['/']);
    });      
  }

  // GOSAND
  maskLoader(show:boolean){
    this.catchLoaderSubject.next(show);
  }

  showSnack(title:any,type?:any,delay?:number,dismissible?:boolean){  
    if(typeof this.bs5Utils=='undefined')return;
    if(typeof type=='undefined' || type==null) type='primary';
    if(typeof delay !='number' || parseInt(delay.toString())==0)delay=0;

    /*if (this.bs5UtilsEle && this.bs5UtilsEle.classList) {
      this.bs5UtilsEle.classList.remove(...this.allCls);
      this.bs5UtilsEle.classList.add(...this.bottomRightCls);
    } */
    
    let toastObj :any = {           
      type : type,
      title: title       
    };

    if(typeof delay ==='number'){
      toastObj['delay']=delay;
    }
    if(typeof dismissible === 'boolean' ){
      toastObj['dismissible']= dismissible;
    }
    this.bs5Utils.Snack.show(type,title,delay>0 ? delay : 5000, dismissible);   
  }
  showAlert(title:any, message:any, callback:Function, buttons?:any[], type?:string){
    if(typeof type=='undefined' || type==null) type='success';  
    if(!buttons) buttons = [];
    if (this.modalRef) this.modalRef = null;
    this.modalRef = this.modalService.open(AlertBox, { centered: true, size: 'md', modalDialogClass: 'vr-alert-modal', backdrop:'static'  });
    this.modalRef.componentInstance.title = title;
    this.modalRef.componentInstance.message = message;
    this.modalRef.componentInstance.buttons = buttons;
    this.modalRef.componentInstance.mType = type;

    this.modalRef.result.then((closeEvent: EVENT_DATA) => {   
      if(callback && typeof callback==='function')callback(closeEvent); 
    });
  }
   showAlert__OLD(title:any, message:any, buttons?:any[], type?:string){
    if(typeof this.bs5Utils=='undefined')return;
    if(typeof type=='undefined' || type==null) type='success';  

    if(!buttons) buttons = [];
    let toastObj :any = {           
      type : type,
      title: title,
      content: message || '',
      centered: true,
      dismissible: buttons.length>0 ? false : true,
      backdrop: 'static',
      keyboard: false,
      focus: false      
    };
    let modelInstance = this.bs5Utils.Modal.show({
      ...toastObj, 
      backdrop: toastObj.dismissible ? true : 'static',
      buttons: (buttons || []).map((buttonObjec:any)=>{
        if(!buttonObjec.hasOwnProperty('class')){
          buttonObjec['class'] = `btn btn-sm btn-${type}`;
        }
        return {
          ...buttonObjec,          
          handler: ()=>{             
            if(buttonObjec.hasOwnProperty('callback') && typeof buttonObjec.callback === 'function'){
              buttonObjec.callback(modelInstance);
            }
          }
        };
      })
    });

    
  }


  showToast(title:any, content:any,type?:any,delay?:number,dismissible?:boolean,buttons?:any,subtitle?:any,icon?:any){   
    if(typeof this.bs5Utils=='undefined')return;
    if(typeof type=='undefined' || type==null) type='primary';

    /*if (this.bs5UtilsEle && this.bs5UtilsEle.classList) {
      this.bs5UtilsEle.classList.remove(...this.allCls);
      this.bs5UtilsEle.classList.add(...this.bottomRightCls);
    }*/
    
    let toastObj :any = {
      title: title,
      content: content,
      type : type      
    };

    if(typeof subtitle !=='undefined' && subtitle!=''){
      toastObj['subtitle']=subtitle;
    }
    if(typeof icon !=='undefined' && icon!=''){
      toastObj['icon']=icon;
    }
    if(typeof buttons !=='undefined' && Array.isArray(buttons) && buttons.length>0){
      toastObj['buttons']=buttons;
    }
    if(typeof delay ==='number'){
      toastObj['delay']=delay;
    }
    if(typeof dismissible === 'boolean' ){
      toastObj['dismissible']=dismissible;
    }
    this.bs5Utils.Toast.show(toastObj);

  }
  //

  buildDataTableParam(dtParam:IDataTableParam) : IRequestQuery  {     
    let columnIndex =  [...dtParam.columns].map((column:IColumn, index: number, array: IColumn[])=>{
      return column.data;
    });      
    let searchString = (dtParam.search && dtParam.search.hasOwnProperty('value') ? dtParam.search.value : "").trim();    
    let queryObject : IRequestQuery = {
      start : dtParam.currentPageIndex || 0,
      length : dtParam.length || 10,    
      orderByField : columnIndex[dtParam.order && dtParam.order[0] ? dtParam.order[0].column : 0],
      //orderByField : dtParam.order && dtParam.order[0] ? dtParam.order[0].column : 0,
      orderType : (dtParam.order && dtParam.order[0] ? dtParam.order[0].dir : 'asc').toUpperCase(),  
      filterJSONData : "{}"    
    };
    if(dtParam.searchColumns && dtParam.searchColumns.length>0){
      queryObject.filterJSONData = JSON.stringify({searchColumns:dtParam.searchColumns});
    }

    //searchColumns
    if(searchString!=""){
      queryObject.filterType = "Contain";
      queryObject.search = searchString;
    }   
    return queryObject;
  }
  async dataTableRequest_ <T> (methodType:METHOD_TYPE,endUrl: string,dtParam:IDataTableParam) : Promise<IDataTableResponse<T>> {
    let queryObject : any = this.buildDataTableParam(dtParam) || {};    
    let httpRequest = null;
    if(methodType==METHOD_TYPE.POST){
      let postParams  = new FormData();
      for(let k in queryObject){
        postParams.append(k, queryObject[k]); 
      }
      httpRequest = this.http.post<IDataTableResponse<T>>(this.APIURL + endUrl, postParams); //queryObject || {}
    }else{
      let queryString = new URLSearchParams(queryObject).toString();
      let requestUrl = endUrl + (endUrl.includes("?") ? "&" :"?") + queryString; 
      httpRequest = this.http.get<IDataTableResponse<T>>(this.APIURL + requestUrl);
    }

    return await lastValueFrom<IDataTableResponse<T>>(httpRequest)
    .then((response:any)=>{
      return <IDataTableResponse<T>>{
        recordsTotal:  response.recordsTotal || 0,
        recordsFiltered:  response.recordsFiltered || 0,
        data: response.dataobject 
      }
    })
    .catch((e:any)=>{      
      return <IDataTableResponse<T>>{
        recordsTotal: e.recordsTotal || 0,
        recordsFiltered: e.recordsFiltered || 0,
        data: []
      };
    });    
  }//EOF dataTableRequest

  
  async dataTableRequest <T,S={}> (methodType: METHOD_TYPE, endUrl: string, dtParam: IDataTableParam, extraParams?:any) : Promise<IDataTableResponse<T,S>> {
    let queryObject : any = this.buildDataTableParam(dtParam) || {};    
    let httpRequest = null;
    if(methodType==METHOD_TYPE.POST){
      let postParams  = new FormData();
      for(let k in queryObject){
        postParams.append(k, queryObject[k]); 
      }  
      for(let j in extraParams || {}){
        postParams.append(j, extraParams[j]); 
      }         
      httpRequest = this.http.post<IDataTableResponse<T,S>>(this.APIURL + endUrl, postParams); //queryObject || {}
    }else{
      let queryString = new URLSearchParams(queryObject).toString();
      let requestUrl = endUrl + (endUrl.includes("?") ? "&" :"?") + queryString; 
      httpRequest = this.http.get<IDataTableResponse<T,S>>(this.APIURL + requestUrl);
    }

    return await lastValueFrom<IDataTableResponse<T,S>>(httpRequest)
    .then((response:any)=>{
      return <IDataTableResponse<T,S>>{
        recordsTotal:  response.recordsTotal || 0,
        recordsFiltered:  response.recordsFiltered || 0,
        data: response.dataobject,
        summary : response.summary,
        EntityTypeID: response.EntityTypeID,
        EntityTypeName: response.EntityTypeName,
        postParamObject : queryObject,
        permissionActionsID : response.permissionActionsID || [],
        SampleExcelFile: response.SampleExcelFile 
      }
    })
    .catch((e:any)=>{ 
      return <IDataTableResponse<T,S>>{
        recordsTotal: e.recordsTotal || 0,
        recordsFiltered: e.recordsFiltered || 0,
        data: [] ,
        postParamObject : queryObject,
        SampleExcelFile: e.url
      };
    });    
  }//EOF dataTableRequest
  
  getDataTablePageIndex(oSettings:any): number {
    return  Math.ceil(oSettings._iDisplayStart / oSettings._iDisplayLength);// + 1;   
  }//EOF getDataTablePageIndex

  toNgbDate(dateString: string): { year: number, month: number, day: number } | null {
      if (!dateString) return null;

      const parts = dateString.split('-');
      if (parts.length !== 3) return null;

      const year = +parts[0];
      const month = +parts[1];
      const day = +parts[2];

      if (!year || !month || !day) return null;

      return { year, month, day };
  }// EOF toNgbDate

  ngbDateToString(date: { year: number; month: number; day: number } | null): string | null {
    if (!date) return null;
    return [date.year, String(date.month).padStart(2, '0'), String(date.day).padStart(2, '0')].join('-');
  }// EOF ngbDateToString

  getRouteRootPath(){    
    let userRootSection:string = this.EntityTypes[this.profile().EntityTypeID] || 'um';    
    const urlSplit =[...new Set((window.location.pathname || "").replace(/[0-9]/g, '').split("/").map((entry:any) => entry.trim()).filter(Boolean))];
    let rootPath = (urlSplit && urlSplit[0] ? urlSplit[0] : 'um').toLowerCase();  
    if(!["um", "sm", "sh"].includes(rootPath)) rootPath = userRootSection;
    return rootPath;
  }

  nameAvatar(fullName:string){   
    const getHindiInitial = (word:string)=>{
      // Match first akshara including conjuncts and vowel signs
      const match = word.match(
        /^[\u0900-\u097F](?:\u094D[\u0900-\u097F])*(?:[\u093A-\u094C\u094E\u094F\u0955-\u0957])?/
      );
      return match ? match[0] : word[0];
    } 
    return fullName
    .trim()
    .split(/\s+/)
    .map(word => {
      // Hindi
      if (/^[\u0900-\u097F]/.test(word)) {
        return getHindiInitial(word);
      }

      // English
      if (/^[A-Za-z]/.test(word)) {
        return word.slice(0, 1).toUpperCase();
      }

      return "";
    })
    .join("");
  }
  maskEmail(email: string): string{
    if (!email || !email.includes('@')) return email;  
    const [username, domain] = email.split('@');
    const [domainName, tld] = domain.split('.');  
    const maskedUsername = username.split('').map((char:string, index:number)=>{
      return  index>0 ? (index % 3 ? char : '*') : char;
    }).join('');   
    //const maskedUsername = username.charAt(0) + '*'.repeat(Math.max(3, username.length - 2)) + username.charAt(1) ; 
    const maskedDomain = domainName.charAt(0) + '*'.repeat(Math.max(3, domainName.length - 1));    
    return `${maskedUsername}@${maskedDomain}.${tld}`;
  }


}



